module.exports = __webpack_public_path__ + "static/media/3.e0548098.mp4";